import { createAsyncThunk } from '@reduxjs/toolkit';
import { ITableRequestParams } from 'components/Table/constants';
import { getSecureDataRequests } from 'services/secureDataSharing';

export interface IParams extends ITableRequestParams {
  ticketId?: string;
}

export const ThunkGetSecureDataRequests = createAsyncThunk(
  'secureDataSharing/getRequests',
  (params: IParams) =>
    getSecureDataRequests({
      _start: params.start,
      _end: params.end,
      ticketId: params.ticketId,
      _order: 'desc',
    }).then(res => ({
      data: res.data,
      totalCount: res.headers['x-total-count'],
      start: params.start,
      end: params.end,
      ticketId: params.ticketId,
    })),
);
